import React, { useEffect, useState } from 'react';
import MainMeterSelector from './MainMeterSelector';
import SiteService from './SiteService';
import { Link, useParams } from 'react-router-dom';
import {
  Paper, Typography, Table, TableHead, TableBody, TableRow, TableCell,
  Button, IconButton, Menu, MenuItem, Dialog, DialogTitle,
  DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function InvoiceList() {
  const { mainMeterId: initialMainMeterId } = useParams();
  const [mainMeterId, setMainMeterId] = useState(initialMainMeterId);
  const [invoices, setInvoices] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuInvoiceId, setMenuInvoiceId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  useEffect(() => {
    if (mainMeterId) {
      SiteService.getInvoicesByMainMeter(mainMeterId).then(res => setInvoices(res.data));
    }
  }, [mainMeterId]);

  const openMenu = (e, id) => {
    setAnchorEl(e.currentTarget);
    setMenuInvoiceId(id);
  };
  const closeMenu = () => setAnchorEl(null);

  const openDialog = () => {
    setDialogOpen(true);
    closeMenu();
  };
  const openCancelDialog = () => {
    setCancelDialogOpen(true);
    closeMenu();
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setMenuInvoiceId(null);
  };
  const closeCancelDialog = () => {
    setCancelDialogOpen(false);
    setMenuInvoiceId(null);
  };

  const confirmDelete = () => {
    if (!menuInvoiceId) return;
    SiteService.deleteInvoice(mainMeterId, menuInvoiceId)
      .then(() => {
        setInvoices(prev => prev.filter(i => i.invoiceId !== menuInvoiceId));
        toast.success('Fatura başarıyla silindi!');
      })
      .catch(() => toast.error('Silme işlemi başarısız!'));
    closeDialog();
  };
  const confirmCancel = () => {
    if (!menuInvoiceId) return;
    SiteService.cancelAllocation(mainMeterId, menuInvoiceId)
      .then(() => {
        if (mainMeterId) {
          SiteService.getInvoicesByMainMeter(mainMeterId).then(res => setInvoices(res.data));
        }
        toast.success('Fatura paylaşımları iptal edildi!');
      })
      .catch(() => toast.error('Silme işlemi başarısız!'));
    closeCancelDialog();
  };

  return (
    <Paper sx={{ p: 3 }}>
      <MainMeterSelector
        mainMeterId={mainMeterId}
        setMainMeterId={setMainMeterId}
      />

      <Typography variant="h5" align="center" gutterBottom>
        Faturalar
      </Typography>

      <Button
        variant="contained"
        component={Link}
        to={`/add-invoice/${mainMeterId}`}
        color="secondary"
        sx={{ mb: 2 }}
        disabled={!mainMeterId}
      >
        Fatura Girişi
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Başlangıç Tarihi</TableCell>
            <TableCell>Bitiş Tarihi</TableCell>
            <TableCell>Fatura Tutarı</TableCell>
            <TableCell>Fatura Seri No</TableCell>
            <TableCell>Paylaştırıldı</TableCell>
            <TableCell align="right">İşlemler</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices.map(inv => (
            <TableRow key={inv.invoiceId} hover>
              <TableCell>{inv.startDate}</TableCell>
              <TableCell>{inv.endDate}</TableCell>
              <TableCell>{inv.amount}</TableCell>
              <TableCell>{inv.serialNumber}</TableCell>
              <TableCell>
                {inv.allocated ? 'Evet' : 'Hayır'}
              </TableCell>
              <TableCell align="right">
                <IconButton onClick={e => openMenu(e, inv.invoiceId)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        <MenuItem component={Link}
          to={`/update-invoice/${mainMeterId}/${menuInvoiceId}`}
          onClick={closeMenu}
        >
          Güncelle
        </MenuItem>

        {invoices.find(inv => inv.invoiceId === menuInvoiceId)?.allocated ? (
          <>
            <MenuItem
              component={Link}
              to={`/rating-summary/${mainMeterId}/${menuInvoiceId}`}
              onClick={closeMenu}
            >
              Sonuçları Görüntüle
            </MenuItem>

            <MenuItem onClick={openCancelDialog}>
              Hesaplamaları İptal Et
            </MenuItem>
          </>
        ) : (
          <MenuItem
            component={Link}
            to={`/allocate-invoice/${mainMeterId}`}
            onClick={closeMenu}>
            Süzme Sayaçlara Paylaştır
          </MenuItem>
        )}


        <MenuItem onClick={openDialog}>
          Faturayı Sil
        </MenuItem>
      </Menu>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu faturayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>İptal</Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>
            Sil
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={cancelDialogOpen} onClose={closeCancelDialog}>
        <DialogTitle>İptal Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu faturanın Süzme sayaçlar için hesaplanan ücretlerini iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCancelDialog}>İptal</Button>
          <Button color="error" variant="contained" onClick={confirmCancel}>
            Evet
          </Button>
        </DialogActions>
      </Dialog>


      <ToastContainer position="top-right" autoClose={2000} />
    </Paper>
  );
}
